import React from 'react';
import styles from './styles.css';

const Indonesia = () => {
  return (
    <div className={styles['tnc-wrapper']}>
      <ol type="I">
        <b>
          <li>DEFINISI</li>
        </b>
        <ol type="1">
          <li>
            "<b>AKULAKU</b>" adalah suatu penyelenggara sistem elektronik
            berbentuk aplikasi mobile (platform).
          </li>
          <li>
            "<b>Aplikasi AKULAKU</b>" adalah aplikasi mobile pencarian toko dan
            barang yang dijual oleh Penjual terdaftar, yang memberikan layanan
            fasilitas tertentu bagi Penjual terdaftar untuk menawarkan fitur
            pembayaran cicilan tanpa kartu kredit untuk pembelian barang yang
            dijual oleh Penjual melalui Aplikasi AKULAKU dan juga dapat
            digunakan sebagai solusi pembayaran waktu seketika di toko Penjual.
          </li>
          <li>
            "<b>Pengguna</b>" adalah pihak yang menggunakan layanan AKULAKU,
            termasuk namun tidak terbatas pada pembeli, penjual, ataupun pihak
            lain yang mengunduh Aplikasi AKULAKU. Pengguna merupakan pihak yang
            cakap dan mampu untuk mengikatkan dirinya dalam sebuah perjanjian
            yang sah menurut hukum yang berlaku di Republik Indonesia.
          </li>
          <li>
            "<b>Pembeli</b>" adalah User terdaftar yang melakukan permintaan
            atas suatu Produk yang dijual oleh penjual terdaftar dan/atau yang
            melakukan pembayaran melalui Aplikasi AKULAKU.
          </li>
          <li>
            "<b>Penjual</b>" adalah User terdaftar yang menyetujui untuk
            penjualan atas suatu Produk kepada User dan bersedia menerima
            pembayaran melalui Aplikasi AKULAKU.
          </li>
          <li>
            "<b>Rekening Virtual AKULAKU</b>" adalah rekening bersama yang
            disepakati oleh AKULAKU dan User untuk proses transaksi jual beli di
            Aplikasi AKULAKU termasuk penggunaan Program Cicilan.
          </li>
          <li>
            "<b>Batas Kredit</b>" adalah jumlah maksimum kredit yang dapat
            dimasukkan oleh Pelanggan ke dalam aplikasi AKULAKU miliknya atas
            persetujuan AKULAKU, untuk digunakan sebagai solusi pembayaran
            terhadap transaksi yang dilakukannya pada toko MERCHANT.
          </li>
          <li>
            "<b>Barcode</b>" adalah kode-kode untuk angka dan huruf yang terdiri
            dari kombinasi bar (garis) dengan berbagai jarak. Hal ini merupakan
            salah satu cara untuk memasukkan data ke dalam komputer. Ketika
            angka tersebut di scan oleh cashier maka kode tersebut secara
            otomatis akan langsung terhubung ke data barang.
          </li>
          <li>
            "<b>Barcode Scanner</b>" adalah mobile aplikasi AKULAKU menggunakan
            Camera Based Barcode Readers sehingga dapat digunakan sebagai alat
            pembayaran produk MERCHANT dengan memotong Batas Kredit Pelanggan
            pada aplikasi AKULAKU. Hasil barcode scanner tersebut berisikan
            data-data dari berbagai produk seperti nama MERCHANT, nama produk,
            harga dan data pendukung lain.
          </li>
          <li>
            "<b>Syarat dan Ketentuan</b>" adalah perjanjian antara Pengguna dan
            AKULAKU yang berisikan seperangkat peraturan yang mengatur hak,
            kewajiban, tanggung jawab Pengguna dan AKULAKU, serta tata cara
            penggunaan sistem dan layanan dalam Aplikasi AKULAKU.
          </li>
        </ol>

        <b>
          <li>KETENTUAN PENJUALAN</li>
        </b>
        <ol type="1">
          <li>
            Penjual diwajibkan untuk terlebih dahulu mengajukan aplikasi kepada
            AKULAKU dan kemudian memperoleh persetujuan AKULAKU dalam bentuk
            suatu kesepakatan tertulis yaitu Perjanjian Penjual sebelum menjual
            Produk dan/atau Jasa serta menerima solusi pembayaran transaksi di
            Aplikasi AKULAKU.
          </li>
          <li>
            Penjual dilarang memanipulasi harga Produk dan/atau Jasa untuk
            tujuan apapun, serta dilarang memanipulasi data transaksi Produk
            dan/atau Jasa, termasuk namun tidak terbatas dengan cara
            memanipulasi data transaksi demi meningkatkan jumlah transaksi
            Penjual melalui Aplikasi AKULAKU.
          </li>
          <li>
            Penjual wajib memberikan data, informasi dan deskripsi Produk dengan
            lengkap dan jelas sesuai dengan kondisi dan kualitas Produk yang
            dijualnya. Penjual memahami dan menyetujui bahwa AKULAKU berhak
            membatalkan pembayaran transaksi Produk dan/atau Jasa dalam hal
            terdapat ketidaksesuaian antara data, informasi dan deskripsi Produk
            dan/atau Jasa yang diberikan Penjual dengan Produk dan/atau Jasa
            yang diterima oleh Pembeli.
          </li>
          <li>
            Penjual dilarang membuat syarat dan ketentuan pembelian Produk
            dan/atau Jasa yang melanggar hukum dan peraturan perundang-undangan
            yang berlaku di Indonesia, termasuk namun tidak terbatas kepada
            syarat dan ketentuan klausula baku yang (i) tidak menerima komplain,
            (ii) tidak menerima pengembalian barang, (iii) tidak menerima
            pengembalian dana, (iv) produk tidak memiliki garansi, (v)
            penyusutan nilai harga.
          </li>
          <li>
            Penjual memahami dan menyetujui bahwa harga Produk dan/atau Jasa
            yang dibayarkan melalui Aplikasi AKULAKU sudah termasuk pajak, dan
            Pajak Penghasilan Penjual akan dilaporkan dan diurus sendiri oleh
            masing-masing Penjual sesuai dengan ketentuan pajak yang berlaku di
            peraturan perundang-undangan di Indonesia.
          </li>
          <li>
            Selama proses penjualan berlangsung, Penjual memahami dan menyetujui
            bahwa AKULAKU dapat sewaktu-waktu melakukan verifikasi dan/atau
            notifikasi kepada Penjual melalui telepon ke nomor Penjual.
            Verifikasi dan/atau notifikasi ini merupakan inisiatif AKULAKU dan
            tidak dapat dianggap sebagai kewajiban AKULAKU, sehingga tidak
            diterimanya panggilan telepon oleh Penjual tidak dapat dijadikan
            alasan Penjual untuk tidak melakukan kewajibannya berdasarkan syarat
            dan ketentuan ini.
          </li>
        </ol>

        <b>
          <li>KETENTUAN PEMBELI</li>
        </b>
        <ol type="1">
          <li>
            Pembeli dapat menggunakan solusi pembayaran melalui aplikasi
            AKULAKU, yaitu menggunakan Barcode Scanner yang terdapat pada Camera
            telephone genggam milik Pembeli untuk melakukan scan pada Barcode
            yang tertera pada Dashboard Penjual. Penjual akan memotong dana
            Pembeli pada Kredit Limit di Aplikasi AKULAKU Pembeli.
          </li>
          <li>
            Saat melakukan pembelian Produk, Pembeli setuju bahwa Pembeli
            bertanggung jawab untuk membaca, memahami, dan menyetujui informasi
            dan deskripsi Produk secara keseluruhan (termasuk namun tidak
            terbatas pada harga, warna, kualitas, fungsi, jenis, spesifikasi,
            dan informasi lainnya) sebelum membuat tawaran atau komitmen untuk
            membeli Produk.
          </li>
          <li>
            Pembeli masuk ke dalam perjanjian yang mengikat secara hukum untuk
            membeli Produk ketika Pembeli membeli suatu Produk dan membayarnya
            menggunakan Aplikasi AKULAKU.
          </li>
          <li>
            Pembeli memahami dan menyetujui bahwa segala transaksi yang
            dilakukan antar Pembeli dan Penjual selain melalui Rekening Virtual
            AKULAKU dan/atau tanpa sepengetahuan AKULAKU (melalui pesan pribadi,
            korespondensi via telepon dengan nomor pribadi, atau upaya lainnya)
            merupakan tanggung jawab pribadi Pembeli.
          </li>
          <li>
            Pembeli menyetujui untuk tidak mengungkapkan atau menyerahkan bukti
            pembayaran Produk kepada pihak lain selain AKULAKU. Dalam hal
            terjadi kerugian akibat pemberitahuan atau penyerahan bukti
            pembayaran oleh Pembeli kepada pihak lain, maka hal tersebut akan
            menjadi tanggung jawab Pembeli.
          </li>
          <li>
            Pembeli memahami dan menyetujui bahwa setiap klaim yang disampaikan
            setelah adanya konfirmasi atau konfirmasi otomatis penerimaan Produk
            bukan merupakan tanggung jawab AKULAKU, namun merupakan tanggung
            jawab Pembeli secara pribadi.
          </li>
          <li>
            Pembeli memahami dan menyetujui bahwa masalah keterlambatan proses
            pembayaran dan biaya tambahan yang disebabkan oleh perbedaan bank
            Pembeli dengan bank Rekening Virtual AKULAKU adalah tanggung jawab
            Pembeli secara pribadi.
          </li>
        </ol>

        <b>
          <li>KETENTUAN PROSES PEMBAYARAN</li>
        </b>
        <ol type="1">
          <li>
            Harga Produk yang terdapat dalam Aplikasi AKULAKU adalah harga yang
            ditetapkan oleh Penjual.
          </li>
          <li>
            Pembeli memilih produk secara waktu seketika kemudian membawanya ke
            kasir untuk dimasukkan data produk, harga, dan data lainnya dalam
            dashboard Penjual kemudian dibayarkan menggunakan Batas Kredit dalam
            aplikasi AKULAKU dengan Barcode Scanner yang ada pada telepon gengam
            Pembeli.
          </li>
          <li>
            Aplikasi AKULAKU saat ini hanya melayani transaksi jual beli Produk
            dan melakukan pembayaran dalam mata uang Rupiah.
          </li>
        </ol>

        <b>
          <li>KETENTUAN PENGEMBALIAN / PERBAIKAN / PENGGANTIAN</li>
        </b>
        <ol type="1">
          <li>
            Pengembalian dana kepada Pembeli hanya dapat dilakukan jika dalam
            keadaan terdapat perbedaan produk, harga, dan data lainnya dalam
            dashboard Penjual dengan produk, harga dan data lainnya pada waktu
            seketika.
          </li>
          <li>
            Semua pengembalian dana akan dilakukan melalui mekanisme pembayaran,
            di mana pengembalian dana akan dilakukan melalui transfer bank ke
            rekening bank pribadi Pembeli dengan syarat rincian rekening bank
            yang diberikan kepada AKULAKU telah lengkap dan akurat. Kegagalan
            atau keterlambatan penerimaan pengembalian dana yang disebabkan
            karena kesalahan pemberian data rekening maupun perbedaan bank
            Pembeli dengan bank rekening AKULAKU adalah tanggung jawab Pembeli
            secara pribadi.
          </li>
          <li>
            Pembeli memahami dan menyetujui bahwa AKULAKU bekerjasama dengan
            pihak ketiga yaitu Xendit untuk melakukan pengembalian dana, dan
            AKULAKU dapat menggunakan data Pembeli bersama Xendit dengan tujuan
            melaksanakan pengembalian dana tersebut.
          </li>
          <li>
            Pengembalian dana akan dilakukan dalam 7-10 hari kerja sejak
            permohonan pengembalian dana diterima dan diberikan persetujuan
            berdasarkan verifikasi AKULAKU.
          </li>
          <li>
            Pembeli memahami dan menyetujui bahwa AKULAKU memiliki hak dan
            kewenangan untuk melakukan perubahan mekanisme pengembalian dana
            tanpa kewajiban pemberitahuan sebelumnya.Semua pengembalian harus
            dilakukan sesuai dengan petunjuk yang ditetapkan dalam Ketentuan
            Pengembalian / Perbaikan Produk pada aplikasi.
          </li>
          <li>
            MERCHANT wajib mengisi dan menyampaikan Informasi Produk yang tidak
            dapat dilakukan proses pergantian / perbaikan pada deskripsi dan
            detail produk.
          </li>
        </ol>

        <b>
          <li>PEMUTUSAN</li>
        </b>
        <ol type="1">
          <li>
            Perjanjian ini akan berakhir dengan segera oleh salah satu pihak
            dengan pemberitahuan tertulis sebelumnya minimal 30 (tiga puluh)
            hari sebelum jangka waktu Perjanjian berakhir.
          </li>
        </ol>

        <b>
          <li>PEMBAHARUAN</li>
        </b>
        <ol type="1">
          <li>
            Syarat dan Ketentuan ini disampaikan secara tertulis dapat mengalami
            perubahan secara sewaktu-waktu dengan disertai pemberitahuan. Dengan
            tetap mengakses dan menggunakan layanan AKULAKU, maka MERCHANT
            dianggap menyetujui perubahan-perubahan dalam Syarat dan Ketentuan
          </li>
        </ol>
      </ol>
    </div>
  );
};

export default Indonesia;
